"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const echo_1 = require("jsAssets/websocket/echo");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const get_1 = __importDefault(require("lodash/get"));
const pulse_confirm_modal_1 = __importDefault(require("../../pulse-confirm-modal/pulse-confirm-modal"));
const helper_1 = require("../../reviews/helper");
const helpers_1 = require("../helpers");
const assetDetailSlice_1 = require("../store/assetDetailSlice");
const reviewSlice_1 = require("../store/reviewSlice");
const asset_detail_content_1 = __importDefault(require("./asset-detail-content"));
const asset_detail_drawer_modules_less_1 = __importDefault(require("./asset-detail-drawer.modules.less"));
require("tippy.js/dist/tippy.css");
const NewRoundAvailableModal = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./new-round-available-modal'))));
const compareArrayAssetIds = (oldArray, newArray) => {
    return (oldArray.length === newArray.length &&
        oldArray
            .sort()
            .every((element, index) => element === newArray.sort()[index]));
};
let oldArrayAssetIds = [];
const CONTENT = (helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.content) || '';
let idNewRoundSocket = 0;
const AssetDetailDrawer = (0, react_1.forwardRef)(({ renderFilesStructure, ticketId, onClose, roundId }, ref) => {
    var _a;
    const { asset, isConfirmationModalVisible, isDirty, isOpenDrawer } = (0, react_redux_1.useSelector)((state) => state.assetDetail);
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const { reviewRound, isLoadingReviewRound, idNewRound, tasks } = (0, react_redux_1.useSelector)((state) => state.review);
    const [isStarred, setIsStarred] = (0, react_1.useState)(false);
    const [loadingStarredItem, setLoadingStarredItem] = (0, react_1.useState)(true);
    const [starredItemId, setStarredItemId] = (0, react_1.useState)('');
    const dispatch = (0, react_redux_1.useDispatch)();
    const linkBtnRef = (0, react_1.useRef)(null);
    const reviewId = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId;
    const text = `#${reviewId}`;
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
        }
    };
    (0, react_1.useEffect)(() => {
        // $(document).on(
        //   'click',
        //   '[data-action="view-asset-details"], [data-action="version-history"], [data-action="view-asset-message"], [data-action="document-approvals"], [data-action="view-asset-finance-document"], [data-action="view-asset-project-dashboard"]',
        //   (e) => {
        //     switch (e.currentTarget.dataset.action) {
        //       case 'version-history':
        //         dispatch(setTab(TabTypes.VERSION_TAB));
        //         dispatch(fetchAssetDetail({ assetId: e.target.dataset.id }));
        //         break;
        //       case 'view-asset-details': {
        //         const { id, brandCatId } = e.currentTarget.dataset;
        //         if (brandCatId !== JDE_BRAND_CAT_ID) {
        //           dispatch(fetchAssetDetail({ assetId: id }));
        //         }
        //         break;
        //       }
        //       case 'view-asset-message':
        //       case 'document-approvals': {
        //         const { assetId, brandCatId } = e.currentTarget.dataset;
        //         if (brandCatId !== JDE_BRAND_CAT_ID) {
        //           dispatch(fetchAssetDetail({ assetId }));
        //         }
        //         break;
        //       }
        //       case 'view-asset-project-dashboard':
        //       case 'view-asset-finance-document': {
        //         const { assetId } = e.currentTarget.dataset;
        //         if (assetId !== 0) {
        //           dispatch(fetchAssetDetail({ assetId }));
        //         }
        //         break;
        //       }
        //       default:
        //     }
        //   }
        // );
    }, [dispatch]);
    const handleUpdateIdNewRound = (id) => {
        dispatch((0, reviewSlice_1.setIdNewRound)(id));
    };
    (0, react_1.useEffect)(() => {
        if (linkBtnRef.current) {
            utilities_1.default.copyToClipboard(linkBtnRef.current);
        }
    }, [linkBtnRef.current]);
    (0, react_1.useEffect)(() => {
        if (isLoadingReviewRound || loadingStarredItem) {
            utilities_1.default.blockPage('Loading...');
        }
        else {
            utilities_1.default.unblockPage();
        }
    }, [isLoadingReviewRound, loadingStarredItem]);
    (0, react_1.useEffect)(() => {
        if (CONTENT === 'passport-reviews') {
            // review-detail deep links handle
            const handleDeepLinksRound = () => {
                const { hash } = window.location;
                const { state } = window.history;
                if (hash && state) {
                    dispatch((0, reviewSlice_1.setIdNewRound)(state.roundId || 0));
                }
            };
            if (window.location) {
                handleDeepLinksRound();
            }
            window.addEventListener('hashchange', handleDeepLinksRound, false);
            return () => {
                return window.removeEventListener('hashchange', handleDeepLinksRound);
            };
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (idNewRound && Number(idNewRound) > 0) {
            dispatch((0, reviewSlice_1.fetchReviewRounds)({ roundId: idNewRound }));
            dispatch((0, reviewSlice_1.fetchReviewTasks)({ roundId: idNewRound }));
        }
    }, [idNewRound]);
    const closeDrawer = () => {
        dispatch((0, assetDetailSlice_1.setOpenDrawer)(false));
        if (onClose) {
            onClose();
        }
        const reviewGridAssetDetailContainer = document.querySelector('#review-detail');
        if (reviewGridAssetDetailContainer) {
            const reviewGridAssetDetailRoot = (0, client_1.createRoot)(reviewGridAssetDetailContainer);
            reviewGridAssetDetailRoot.unmount();
        }
        window.history.pushState('', '#', window.location.pathname);
    };
    const handleCloseDrawer = () => {
        if (isDirty) {
            dispatch((0, assetDetailSlice_1.showConfirmationModal)(undefined));
            return;
        }
        closeDrawer();
    };
    const handleConfirmCloseDrawer = () => {
        dispatch((0, assetDetailSlice_1.closeConfirmationModal)(undefined));
        closeDrawer();
    };
    const closeConfirmModal = () => {
        dispatch((0, assetDetailSlice_1.closeConfirmationModal)(undefined));
    };
    (0, react_1.useEffect)(() => {
        if (idNewRound && Number(idNewRound) > 0) {
            idNewRoundSocket = idNewRound;
        }
        if (helpers_1.WEBSOCKET_CONFIG.websocket_enabled) {
            const echo = (0, echo_1.getOrCreateEcho)();
            if (!echo) {
                return undefined;
            }
            echo
                .channel('ziflow-asset-detail')
                .listen('.ziflow-event-review-detail', (response) => {
                const convertResponse = (0, utilities_1.camelizeKeys)(response.data);
                console.log('Review detail websockets ->>', convertResponse);
                delete convertResponse.updatedAt;
                if (idNewRoundSocket &&
                    Number(idNewRoundSocket) === Number(convertResponse.roundId)) {
                    dispatch((0, reviewSlice_1.setReviewRound)(convertResponse));
                }
            });
        }
        return () => {
            if (window.Echo) {
                window.Echo.leaveChannel('ziflow-asset-detail');
            }
        };
    }, [idNewRound]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        dispatch,
    }));
    (0, react_1.useEffect)(() => {
        if (Number(roundId) > 0) {
            handleUpdateIdNewRound(roundId);
        }
    }, [roundId]);
    const handleListenerEventUpdateIdRound = (e) => {
        const idLastRound = e.detail || 0;
        handleUpdateIdNewRound(idLastRound);
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('reload-review-detail', handleListenerEventUpdateIdRound);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            oldArrayAssetIds = [];
            document.removeEventListener('reload-review-detail', handleListenerEventUpdateIdRound, false);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (Array.isArray(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources)) {
            if (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources.every((source) => source.type === 'asset')) {
                const reviewAssetId = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources.filter((source) => {
                    return source.type === 'asset' && source.asset;
                }).map((assetSource) => { var _a, _b; return (_b = (_a = assetSource === null || assetSource === void 0 ? void 0 : assetSource.asset) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0; });
                if (!compareArrayAssetIds(reviewAssetId, oldArrayAssetIds)) {
                    dispatch((0, assetDetailSlice_1.fetchAssetDetail)({ assetId: reviewAssetId }));
                    oldArrayAssetIds = reviewAssetId;
                }
            }
        }
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources]);
    (0, react_1.useEffect)(() => {
        if (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId) {
            const fetchData = async () => {
                var _a, _b;
                const url = `${window.pulse.config.urls.app}api/starred-items?filter[starred_item_type_label]=Review&filter[starred_item_id]=${reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId}`;
                try {
                    setLoadingStarredItem(true);
                    const res = await pulse_components_1.v2Endpoint.get(url);
                    const data = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                    if (data === null || data === void 0 ? void 0 : data.length) {
                        setIsStarred(true);
                        setStarredItemId((_b = data[0]) === null || _b === void 0 ? void 0 : _b.id);
                    }
                }
                catch (error) {
                    utilities_1.default.notification.danger('Error fetching starred state');
                }
                finally {
                    setLoadingStarredItem(false);
                }
            };
            fetchData();
        }
    }, [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseDrawer, { closeDrawerHandler: handleCloseDrawer, isV3Component: true, DrawerProps: {
                anchor: 'right',
                open: isOpenDrawer,
                onClose: handleCloseDrawer,
                // Fix couldn't add media resources on modal.
                ModalProps: {
                    disableEnforceFocus: true,
                },
            }, PulseModalHeaderProps: {
                primaryText: 'Review ID:',
                closeButtonTooltip: '',
                headerSecondaryIconClasses: 'fa-solid fa-file-magnifying-glass',
                itemId: reviewId,
                hasStarredIcon: true,
                isStarred,
                starredIconProps: {
                    starUrl: `${window.pulse.config.urls.app}api/starred-items`,
                    starMethod: pulse_components_1.METHODS.POST,
                    unstarUrl: isStarred
                        ? `${window.pulse.config.urls.app}api/starred-items/${starredItemId}`
                        : '',
                    unstarMethod: pulse_components_1.METHODS.DELETE,
                    onClick: () => {
                        const event = new CustomEvent('refresh-starred-grid');
                        window.dispatchEvent(event);
                    },
                    payload: {
                        data: {
                            type: 'starred-items',
                            attributes: {
                                starred_item_type_label: 'Review',
                                starred_item_id: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId,
                            },
                        },
                    },
                    starredTooltip: 'Click to unstar Review. It will be removed from your Starred list.',
                    unstarredTooltip: 'Click to star Review. It will be added to your Starred list.',
                },
                classes: {
                    root: asset_detail_drawer_modules_less_1.default['drawer-header'],
                },
                ...((tasks === null || tasks === void 0 ? void 0 : tasks.length) && {
                    additionalContent: (react_1.default.createElement("span", { className: (0, clsx_1.default)(asset_detail_drawer_modules_less_1.default['linked-tasks']) },
                        react_1.default.createElement(pulse_components_1.PulseWithMore, { classes: {
                                root: asset_detail_drawer_modules_less_1.default['linked-tasks-with-more'],
                                more: {
                                    label: {
                                        root: asset_detail_drawer_modules_less_1.default['linked-tasks__more-label'],
                                        active: asset_detail_drawer_modules_less_1.default['linked-tasks__more-active'],
                                    },
                                    root: asset_detail_drawer_modules_less_1.default['linked-tasks__more'],
                                },
                            }, maxWidth: 230, childrenKey: "linked-tasks-id", TippyPropsHidden: {
                                arrow: true,
                                appendTo: document.body,
                            }, customRenderHiddenTippyContent: (attr, hiddenChildrenArray) => {
                                if (!tasks) {
                                    return react_1.default.createElement(react_1.default.Fragment, null);
                                }
                                return (react_1.default.createElement("div", { className: asset_detail_drawer_modules_less_1.default['linked-tasks__hiddenTippy'], ...attr }, hiddenChildrenArray === null || hiddenChildrenArray === void 0 ? void 0 :
                                    hiddenChildrenArray.map((hiddenChildren) => {
                                        const ticketIdEl = (0, get_1.default)(hiddenChildren, 'props.label', '');
                                        const taskDetail = tasks === null || tasks === void 0 ? void 0 : tasks.find((t) => (t === null || t === void 0 ? void 0 : t.ticketid) === Number(ticketIdEl));
                                        return (react_1.default.createElement("a", { className: asset_detail_drawer_modules_less_1.default['hidden-task-tooltip'], href: taskDetail === null || taskDetail === void 0 ? void 0 : taskDetail.ticketUrl, target: "_blank", rel: "noreferrer", key: taskDetail === null || taskDetail === void 0 ? void 0 : taskDetail.ticketid },
                                            "#", taskDetail === null || taskDetail === void 0 ? void 0 :
                                            taskDetail.ticketid,
                                            ": ", taskDetail === null || taskDetail === void 0 ? void 0 :
                                            taskDetail.title));
                                    }),
                                    react_1.default.createElement("div", { className: (0, clsx_1.default)('tippy-arrow', asset_detail_drawer_modules_less_1.default['linked-tasks__hiddenTippy-arrow']), "data-popper-arrow": true })));
                            } }, tasks === null || tasks === void 0 ? void 0 : tasks.map((task) => (react_1.default.createElement(pulse_components_1.PulseLabel, { classes: {
                                root: asset_detail_drawer_modules_less_1.default['linked-tasks__item'],
                                labelText: asset_detail_drawer_modules_less_1.default['linked-tasks__label'],
                            }, label: `${task === null || task === void 0 ? void 0 : task.ticketid}`, key: task === null || task === void 0 ? void 0 : task.ticketid, icon: true, iconComponent: react_1.default.createElement("i", { className: "fa-solid fa-list-check" }), onClick: () => {
                                window.open(task === null || task === void 0 ? void 0 : task.ticketUrl, '_blank', 'noopener,noreferrer');
                            } })))))),
                }),
            }, drawerFooterComponent: react_1.default.createElement(react_1.default.Fragment, null) }, asset && (react_1.default.createElement(asset_detail_content_1.default, { roundId: roundId, ticketId: ticketId || 0, renderFilesStructure: renderFilesStructure, isVisible: isVisible }))),
        react_1.default.createElement(pulse_confirm_modal_1.default, { onConfirmClick: handleConfirmCloseDrawer, onModalClose: closeConfirmModal, open: isConfirmationModalVisible },
            react_1.default.createElement("h4", null, "You have unsaved changes. Do you want to continue?")),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(react_1.default.Fragment, null) }, (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber) !== (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.lastRoundNumber) &&
            ((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.redirectRound) && (react_1.default.createElement(NewRoundAvailableModal, { open: true })))));
});
AssetDetailDrawer.displayName = 'AssetDetailDrawer';
exports.default = AssetDetailDrawer;
